import uniq from 'lodash/uniq';

import * as copy from 'src/templates/copy';
import {
  INVALID_IRI_MATCHER,
  IRI_STARTS_WITH_MATCHER,
} from 'src/utils/removeInvalidIriChars';

export const validateProjectModelName = (name: string) => {
  if (!name.trim()) {
    return copy.components.projectModelDialog.validation.nameRequired;
  }

  if (name === 'data') {
    return copy.components.projectModelDialog.validation.nameInvalidData;
  }

  return '';
};

export const validateProjectModelIri = (iri: string): string => {
  if (!iri) {
    return copy.components.projectModelDialog.validation.namespaceRequired;
  }

  if (!iri.match(IRI_STARTS_WITH_MATCHER)) {
    return copy.components.projectModelDialog.validation.namespaceStartsWith;
  }

  if (!iri.includes(':')) {
    return copy.components.projectModelDialog.validation.namespaceSemicolon;
  }

  const invalidChars = iri.match(INVALID_IRI_MATCHER);
  if (invalidChars) {
    return copy.components.projectModelDialog.validation.namespaceChars(
      uniq(invalidChars)
    );
  }

  return '';
};
